var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_355",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_12",
    x: 4.601,
    y: 4.6,
    width: 32.799,
    height: 32.799,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPRINKLER_ROUND",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_355)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_355-2",
    "data-name": "Pfad 355",
    fill: "#f5f5f5",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_12)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_12-2",
    "data-name": "Vereinigungsmenge 12",
    className: "cls-1",
    d: "M5044.8-2767.8v-2h2v2Zm8.266-4.655,1.415-1.413,1.415,1.413-1.415,1.414Zm-17.428-.064,1.415-1.414,1.414,1.414-1.414,1.415Zm9.162.719v-2h2v2Zm5.478-3.48,1.415-1.414,1.414,1.414-1.414,1.415Zm-11.81-.028,1.413-1.415,1.415,1.415-1.415,1.414Zm1.632-5.891a5.7,5.7,0,0,1,5.7-5.7,5.7,5.7,0,0,1,5.7,5.7,5.7,5.7,0,0,1-5.7,5.7A5.634,5.634,0,0,1,5040.1-2781.2Zm2,0a3.757,3.757,0,0,0,3.7,3.7,3.757,3.757,0,0,0,3.7-3.7,3.757,3.757,0,0,0-3.7-3.7A3.757,3.757,0,0,0,5042.1-2781.2Zm1.7,0a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1,5043.8-2781.2Zm13.4,1v-2h2v2Zm-4,0v-2h2v2Zm-16.8,0v-2h2v2Zm-4,0v-2h2v2Zm17.9-6.89,1.415-1.415,1.414,1.415-1.414,1.413Zm-11.81-.028,1.413-1.414,1.415,1.414-1.415,1.415Zm14.638-2.763,1.415-1.414,1.415,1.414-1.415,1.415Zm-17.426-.065,1.413-1.414,1.415,1.414-1.415,1.415Zm9.095,1.346v-2h2v2Zm0-4v-2h2v2Z",
    transform: "translate(-5024.8 2802.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerRound);
export default __webpack_public_path__ + "static/media/sprinkler-round.d222611adae8c46aecddb2ca59d3ddfc.svg";
export { ForwardRef as ReactComponent };